// @flow

import styled from "styled-components";

const Header = styled.div`
  background: #fff;
  box-shadow: ${props => props.theme.shadow}
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
`;

const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: ${props => props.theme.header.height};
`;

const HeaderLogo = styled.div`
  display: flex;
  flex: 1;
`;

const HeaderMenu = styled.div`
  display: inline-flex;
  flex: 4;
`;

const HeaderMenuItem = styled.div`
  margin: 0 25px;
`;

export { Header, HeaderContainer, HeaderLogo, HeaderMenu, HeaderMenuItem };



// WEBPACK FOOTER //
// ./src/components/Header/components/index.js